import TravianVersion from "../../enum/version";
import * as Layers from './layers';
import {TroopData} from "./types";
import {merge} from "../../../helper/arrayHelper";
import {fillPartialFeaturesWithDefaults} from "../../Helper/TravianVersionHandling";
import {TravianVersionWithPartialFeatures} from "../../Version";

export default function getTroopData(travianConfig: TravianVersionWithPartialFeatures): TroopData {
    const { features, version } = fillPartialFeaturesWithDefaults(travianConfig);
    let data = {};

    if (version === TravianVersion.Legends) {
        data = {
            ...Layers.legendsDefault,
            ...Layers.legendsEgyptAndHun,
            ...Layers.legendsSpartan,
            ...Layers.legendsViking,
        };

        if (features.tribeBalancing.roman2023) {
            data = merge(data, Layers.legendsRoman2023);
        }
        if (features.tribeBalancing.teuton2024) {
            data = merge(data, Layers.legendsTeuton2024);
        }
        if (features.tribeBalancing.gaul2024) {
            data = merge(data, Layers.legendsGaul2024);
        }
        if (features.tribeBalancing.romanAS2024) {
            data = merge(data, Layers.legendsRomanAS2024);
        }
    }

    return data;
}
